import { Injectable, signal, effect } from '@angular/core';

export type ThemeMode = 'light' | 'dark' | 'system';

const THEME_STORAGE_KEY = 'vitails_theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly themeMode = signal<ThemeMode>(this.loadTheme());
  readonly isDark = signal<boolean>(false);

  constructor() {
    effect(() => {
      const mode = this.themeMode();
      this.applyTheme(mode);
      localStorage.setItem(THEME_STORAGE_KEY, mode);
    });

    // Listen for system theme changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (this.themeMode() === 'system') {
        this.applyTheme('system');
      }
    });
  }

  setTheme(mode: ThemeMode): void {
    this.themeMode.set(mode);
  }

  private loadTheme(): ThemeMode {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'system') {
      return stored;
    }
    return 'system';
  }

  private applyTheme(mode: ThemeMode): void {
    const dark = mode === 'dark' || (mode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    this.isDark.set(dark);
    document.documentElement.classList.toggle('dark-theme', dark);
    document.documentElement.classList.toggle('light-theme', !dark);
  }
}
